import { render } from "./SystemAlertsView.vue?vue&type=template&id=2fee94d5&scoped=true&ts=true"
import script from "./SystemAlertsView.vue?vue&type=script&lang=ts"
export * from "./SystemAlertsView.vue?vue&type=script&lang=ts"

import "./SystemAlertsView.vue?vue&type=style&index=0&id=2fee94d5&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fee94d5"]])

export default __exports__